import Sidebar from '../envelope/Sidebar';
import TopBar from '../envelope/TopBar';
import TestPattern from '../CreatePages/TestPattern';
import TestCard from './TestCard';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Plus from '../media/imagen/Plus.png'

const TestsPage = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [showTestPattern, setShowTestPattern] = useState(false);
  const [testPatterns, setTestPatterns] = useState([]);
  const [companyId, setCompanyId] = useState('');
  const [userCompanyId, setUserCompanyId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedTest, setSelectedTest] = useState(null);
  const [sortOption, setSortOption] = useState('none'); // 'none', 'newest', 'oldest'
  const [tagFilters, setTagFilters] = useState({
    parametricSociometry: false,
    nonParametricSociometry: false,
    leadership: false,
    teamRole: false
  });
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearchActive, setIsSearchActive] = useState(false);
  const navigate = useNavigate();


  const handleSaveSuccess = () => {
    setShowTestPattern(false);
  };

  // Загрузка company_id пользователя
  const fetchUserCompanyId = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch('http://185.250.149.189:8000/api/v1/Company', {
        headers: { 'Authorization': `Token ${token}` }
      });
      
      if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
      
      const data = await response.json();
      return data.Company?.id || null;
    } catch (error) {
      console.error('Ошибка загрузки компании:', error);
      setError('Не удалось загрузить информацию о компании');
      return null;
    }
  };

  // Загрузка шаблонов тестов
  const fetchTestPatterns = async () => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        console.error('Токен авторизации не найден');
        return [];
      }

      const response = await fetch('http://185.250.149.189:8000/api/v1/TestPatterns', {
        method: 'GET',
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) throw new Error(`Ошибка HTTP: ${response.status}`);
      
      const data = await response.json();
      return data.patterns || [];
    } catch (error) {
      console.error('Ошибка при получении шаблонов тестов:', error);
      setError('Не удалось загрузить шаблоны тестов');
      return [];
    }
  };

  // Загрузка всех данных
  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      try {
        // Загружаем данные параллельно
        const [userCompanyId, patterns] = await Promise.all([
          fetchUserCompanyId(),
          fetchTestPatterns()
        ]);
        
        setUserCompanyId(userCompanyId);
        setTestPatterns(patterns);
        setCompanyId(userCompanyId);
      } catch (error) {
        console.error('Ошибка загрузки данных:', error);
        setError('Произошла ошибка при загрузке данных');
      } finally {
        setIsLoading(false);
      }
    };
    
    loadData();
  }, []);

  // Фильтрация шаблонов по company_id
  const filteredPatterns = userCompanyId === 1 
    ? testPatterns 
    : testPatterns.filter(pattern => pattern.company_id === userCompanyId);

  // Фильтрация по тегам (исправленная версия)
  const filterByTags = (patterns) => {
    // Если ни один фильтр не выбран - возвращаем все
    if (!tagFilters.sociometry && !tagFilters.leadership && !tagFilters.teamRole) {
      return patterns;
    }
    
    return patterns.filter(pattern => {
      const tags = pattern.question_types || [];
      
      // Проверяем соответствие каждому фильтру
      const hasSociometry = tagFilters.sociometry && tags.some(tag => 
        tag.includes("Социометрия") || tag.includes("социометрия")
      );
      
      const hasLeadership = tagFilters.leadership && tags.some(tag => 
        tag.includes("Лидерство") || tag.includes("лидерство")
      );
      
      const hasTeamRole = tagFilters.teamRole && tags.some(tag => 
        tag.includes("Роль в команде") || tag.includes("роль в команде")
      );
      
      return hasSociometry || hasLeadership || hasTeamRole;
    });
  };

  // Фильтрация по поисковому запросу
  const filterBySearch = (patterns) => {
    if (!searchQuery.trim()) return patterns;
    
    const queryWords = searchQuery.toLowerCase().split(/\s+/);
    
    return patterns.filter(pattern => {
      const name = pattern.name?.toLowerCase() || '';
      
      // Проверяем, что все слова из запроса присутствуют в названии
      return queryWords.every(word => name.includes(word));
    });
  };

  // Сортировка тестов
  const sortTests = (patterns) => {
    if (sortOption === 'none') return [...patterns];
    
    return [...patterns].sort((a, b) => {
      const dateA = new Date(a.date_created);
      const dateB = new Date(b.date_created);
      
      return sortOption === 'newest' 
        ? dateB - dateA 
        : dateA - dateB;
    });
  };

  // Применяем все фильтры и сортировку
  const filteredByTags = filterByTags(filteredPatterns);
  const filteredBySearch = filterBySearch(filteredByTags);
  const filteredAndSortedPatterns = sortTests(filteredBySearch);

  // Обработчик изменения фильтров
  const handleTagFilterChange = (filterName) => {
    setTagFilters(prev => ({
      ...prev,
      [filterName]: !prev[filterName]
    }));
  };

  // Обработчик поиска
  const handleSearch = (e) => {
    if (e.key === 'Enter' || e.type === 'click') {
      setIsSearchActive(true);
    }
  };

  // Обработчик сброса поиска
  const handleClearSearch = () => {
    setSearchQuery('');
    setIsSearchActive(false);
  };

  return (
    <div className="dashboard">
      <Sidebar 
        isCollapsed={isSidebarCollapsed} 
        toggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
      />
      <TopBar isCollapsed={isSidebarCollapsed} />  
      <main className={`main-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="content-container">
          {showTestPattern ? (
            <TestPattern onSaveSuccess={handleSaveSuccess} />
          ) : (
            <>
              {/* Новая структура заголовка */}
              <div className="tests-page-header">
                <div className="tests-main-header">
                  <h1 className="tests-title">Тесты</h1>
                  <button 
                    className="create-test-btn"
                    onClick={() => setShowTestPattern(true)}
                  >
                    <span>Сконструировать новый тест</span>
                    <img src= {Plus} alt='plus' />
                  </button>
                </div>
                
                {/* Поиск */}
                <div className="search-container-figma">
                  <svg className="search-icon-figma" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 14L11.1 11.1M12.6667 7.33333C12.6667 10.2789 10.2789 12.6667 7.33333 12.6667C4.38781 12.6667 2 10.2789 2 7.33333C2 4.38781 4.38781 2 7.33333 2C10.2789 2 12.6667 4.38781 12.6667 7.33333Z" stroke="#14151A" strokeWidth="1.5" strokeLinecap="round"/>
                  </svg>
                  <input
                    type="text"
                    className="search-input-figma"
                    placeholder="Введите название теста или дату его создания"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyPress={handleSearch}
                  />
                </div>
                
                {/* Фильтры и сортировка */}
                <div className="filters-section">
                  <div className="filter-types">
                    <div className="filter-types-label">Типы тестирований</div>
                    <div className="filter-tags-container">
                      <div 
                        className={`filter-tag filter-tag-sociometry ${tagFilters.sociometry ? 'active' : ''}`}
                        onClick={() => handleTagFilterChange('sociometry')}
                      >
                        Социометрия
                      </div>
                      <div 
                        className={`filter-tag filter-tag-leadership ${tagFilters.leadership ? 'active' : ''}`}
                        onClick={() => handleTagFilterChange('leadership')}
                      >
                        Лидерство
                      </div>
                      <div 
                        className={`filter-tag filter-tag-teamrole ${tagFilters.teamRole ? 'active' : ''}`}
                        onClick={() => handleTagFilterChange('teamRole')}
                      >
                        Роль в команде
                      </div>
                    </div>
                  </div>
                  
                  <div className="sort-container">
                    <div className="sort-label">Сортировка</div>
                    <select 
                      className="sort-selector-figma"
                      value={sortOption}
                      onChange={(e) => setSortOption(e.target.value)}
                    >
                      <option value="none">Без сортировки</option>
                      <option value="newest">Сначала новые</option>
                      <option value="oldest">Сначала старые</option>
                    </select>
                  </div>
                </div>
              </div>
              
              {/* Остальная часть кода остается без изменений */}
              {error && (
                <div className="error-message">{error}</div>
              )}
              
              {isLoading ? (
                <div style={{ textAlign: 'center', padding: '50px 0' }}>
                  <p>Загрузка данных...</p>
                </div>
              ) : (
                <div className='test-cards'>
                  <div className="test-cards-container">
                    {filteredAndSortedPatterns.map(pattern => (
                      <TestCard 
                        key={pattern.id} 
                        test={pattern} 
                        onClick={setSelectedTest}
                      />
                    ))}
                  </div>
                  
                  {filteredAndSortedPatterns.length === 0 && !isLoading && (
                    <div style={{ textAlign: 'center', padding: '50px 0' }}>
                      <p style={{ fontSize: '18px', color: '#666' }}>
                        {searchQuery || tagFilters.sociometry || tagFilters.leadership || tagFilters.teamRole
                          ? 'Тесты по выбранным фильтрам не найдены'
                          : userCompanyId === 1
                            ? 'Шаблоны тестов не найдены'
                            : 'Шаблоны тестов для вашей компании не найдены'
                        }
                        <br />
                        Нажмите "Создать новый тест", чтобы создать первый тест.
                      </p>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </main>
    </div>
  );
};

export default TestsPage;